import type { StreamState } from "./stream-state";

/**
 * Биржи инструментов потока §7.6 — источник вариантов биржи в форме правила
 * алерта (design.md stage6-alert-web, решение 4): «Биржи для выбора SHALL
 * браться из инструментов, которые клиент видит в потоке, а не из списка,
 * зашитого в клиент» (spec `web-alerts-screen`). Уникальные и отсортированные,
 * чтобы порядок не прыгал от сообщения к сообщению.
 */
export function streamExchanges(state: StreamState): string[] {
  const set = new Set(state.instruments.map((entry) => entry.instrument.exchange));
  return Array.from(set).sort();
}
